import { PropsWithChildren } from 'react';

import cn from 'classnames';

import { BaseComponentProps } from '../../../types/common';

import styles from './AvatarGroup.module.css';

export interface AvatarGroupProps
  extends PropsWithChildren<BaseComponentProps> {
  /**
   * Whether to reverse the order of the avatars
   */
  isReversedOrder?: boolean;
}

/**
 * AvatarGroup component that displays multiple Avatar components in an overlapping arrangement
 */
export const AvatarGroup: React.FC<AvatarGroupProps> = ({
  children,
  dataTestId,
  isReversedOrder,
}: AvatarGroupProps) => {
  return (
    <div
      className={cn(styles['avatar-group'], {
        [styles['reversed']]: isReversedOrder,
      })}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};
